import MangeDashboard from "./ManageDashboard";
import axios from "axios";
import { useEffect } from "react";
import { useState } from "react";
import AfterLoginNav from "../AfterLoginNav";
import { useNavigate } from "react-router-dom";
import { toPersianNum } from "../../utils/persianNumbers";
import { getTransactionsHistory } from "../../services/bank";
import { getUserBalance } from "../../services/balance";
import { getCommoditiesList } from "../../services/commodities";
import { useMediaQuery } from "react-responsive";

export default function GoldBalance() {
  const navigate = useNavigate();
  const [balance, setBalance] = useState([]);
  const [page, setPage] = useState(1);
  const [hasNext, setHasNext] = useState("");
  const [orders, setOrders] = useState([]);
  const [commodities, setCommodities] = useState([]);
  const [selectedCommodity, setSelectedCommodity] = useState("1");
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 768px)" });

  useEffect(() => {
    function fetchData() {
      getTransactionsHistory(page, 9).then((res) => {
        if (res.status == 200) {
          let data = res?.data?.results;
          let filteredDate = data.filter((item) => item.status !== 0);
          setOrders([...orders, ...filteredDate]);
        }
        setHasNext(res?.data?.next);
      });
    }
    fetchData();
  }, [page]);

  useEffect(() => {
    function fetchData() {
      getCommoditiesList().then((data) => {
        const tmpBalance = [];
        if (data.status === 200) {
          setCommodities(data.data.results);
          for (let el of data.data.results) {
            getUserBalance(el.id).then((res) => {
              if (res.status == 200) {
                const data = res?.data?.data;
                const info = {};
                info.id = el.id;
                info.name = el.name;
                info.balance = data.gold_balance;
                info.color = el?.ui_data?.colors?.primary;
                tmpBalance.push(info);
                setBalance([...tmpBalance]);
              }
            });
          }
        }
      });
    }
    fetchData();
  }, []);

  return (
    <MangeDashboard>
      <AfterLoginNav title={"صندوق طلا و نقره"} hasBack={() => navigate(-1)} />
      <>
        <div className="container margin-for-sandogh-container">
          {isTabletOrMobile && (
            <div className="select-on-mobile-sandogh">
              <select onChange={(e) => setSelectedCommodity(e.target.value)}>
                {commodities.map((el) => (
                  <option value={el.id}>{el.name}</option>
                ))}
              </select>
            </div>
          )}
          <div className="row justify-content-center align-items-center">
            <div className="col-xl-12 col-md-8">
              <div className="existing-gold-amount">
                {isTabletOrMobile ? (
                  <div className={"mobile-sandogh-text-center"}>
                    {[...balance]
                      .filter((el) => `${el.id}` == `${selectedCommodity}`)
                      .map((el) => (
                        <div className="balance-row">
                          <div>مجموع {el.name} موجود در صندوق </div>
                          <div
                            className="balance-amount-info"
                            style={{ color: el.color }}
                          >
                            {!isNaN(el.balance)
                              ? (el.balance + "").split(".")[0]
                              : ""}{" "}
                            گرم و{" "}
                            {(
                              (!isNaN((el.balance + "").split(".")[1]) &&
                              (el.balance + "").split(".")[1] > 0
                                ? Number((el.balance + "").split(".")[1])
                                : 0) + ""
                            ).substring(0, 3)}{" "}
                            سوت
                          </div>
                        </div>
                      ))}
                  </div>
                ) : (
                  <div>
                    <div className="gold-balance-info-row">
                      مجموع موجودی طلا و نقره و زرینو
                    </div>
                    {balance.map((el) => (
                      <div className="balance-row" key={el.key}>
                        مجموع {el.name} ی موجود در صندوق{" "}
                        <span
                          className="balance-amount-info"
                          style={{
                            color: el.color.startsWith("#")
                              ? el.color
                              : "#" + el.color.split("#").join(""),
                          }}
                        >
                          {el.name !== "زرینو" ? (
                            <>
                              {!isNaN(el.balance)
                                ? (el.balance + "").split(".")[0]
                                : ""}{" "}
                              گرم و{" "}
                              {(
                                (!isNaN((el.balance + "").split(".")[1]) &&
                                (el.balance + "").split(".")[1] > 0
                                  ? Number((el.balance + "").split(".")[1])
                                  : 0) + ""
                              ).substring(0, 3)}{" "}
                              سوت
                            </>
                          ) : (
                            <>{el.balance + " زرینو"}</>
                          )}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <div className="action-button-sandogh">
                <button
                  className="form-input-button-custom"
                  onClick={() => navigate("/physical-gold")}
                >
                  تحویل فیزیکی شمش طلا و نقره
                </button>
              </div>
              <div className="sandogh-history-items-container">
                {orders.map(
                  (li) =>
                    li["gold_amount"] != 0 && (
                      <div
                        className="history-sandogh-items"
                        style={{
                          backgroundColor: commodities
                            .find((el) => el.id == li.commodity.id)
                            ?.ui_data?.colors?.primary.startsWith("#")
                            ? commodities.find((el) => el.id == li.commodity.id)
                                ?.ui_data?.colors?.primary
                            : "#" +
                              commodities
                                .find((el) => el.id == li.commodity.id)
                                ?.ui_data?.colors?.primary.split("#")
                                .join(""),
                        }}
                      >
                        <div className="price-gold-and-amount">
                          <span
                            className="gold-balance-amount"
                            style={{
                              color:
                                li.commodity.name === "زرینو" ? "#fff" : "",
                            }}
                          >
                            <img
                              width={25}
                              className="icon-sandogh"
                              src={
                                commodities.find(
                                  (el) => el.id == li.commodity.id
                                )?.ui_data?.icons?.primary
                              }
                            />
                            {(
                              Math.abs(Math.abs(li["gold_amount"])) + ""
                            ).substring(0, 6)}{" "}
                            {li.commodity.name === "زرینو" ? "" : " گرم"}{" "}
                            {toPersianNum(li.commodity.name)}
                          </span>
                          <span
                            className="shop-status"
                            style={{
                              color:
                                li.commodity.name === "زرینو" ? "#fff" : "",
                            }}
                          >
                            {li["status"] === 1 ? (
                              <>بلوکه شده</>
                            ) : li["status"] === 3 ? (
                              <>درخواست لغو شد</>
                            ) : li["status"] === 4 ? (
                              <>درخواست رد شده</>
                            ) : li["status"] === 2 ? (
                              li["type"] === 0 ? (
                                <>واریز شده</>
                              ) : li["type"] === 1 ? (
                                <>برداشت شده</>
                              ) : li["type"] === 3 ? (
                                <>تحویل شده</>
                              ) : li["type"] === 2 || li["type"] === 5 ? (
                                <>
                                  {li["cash_amount"] > 0 &&
                                  li["gold_amount"] < 0
                                    ? "فروخته شده"
                                    : li["cash_amount"] < 0 &&
                                      li["gold_amount"] > 0 &&
                                      "خریداری شده"}
                                </>
                              ) : li["type"] === 4 ? (
                                <>هدیه شده</>
                              ) : (
                                <></>
                              )
                            ) : (
                              <></>
                            )}
                          </span>
                          <span
                            className="gold-balance-date"
                            style={{
                              color:
                                li.commodity.name === "زرینو" ? "#fff" : "",
                            }}
                          >
                            {toPersianNum(li["created_at"].split("T")[0])}
                          </span>
                        </div>
                      </div>
                    )
                )}
                {hasNext && (
                  <button
                    className="btn-submit"
                    onClick={() => setPage(page + 1)}
                  >
                    صفحه بعد
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    </MangeDashboard>
  );
}
